import Favorite from '../src/Favorite/index.tsx';
export default Favorite;
